import { makeAutoObservable } from "mobx";
import { fetchUserInfo } from "../http/userAPI";
import { UserInfo } from "../types/types";
import presaleStore from "./presaleStore";
import { fetchClient } from "../http";

export default class UserStore {
  _user: Record<string, any>;
  _isAuth: boolean;
  _userInfo: UserInfo | null = null;
  private _isLoading: boolean = false;

  constructor() {
    this._user = {};
    this._isAuth = false;
    makeAutoObservable(this);
  }
  setUser(user: Record<string, any>) {
    this._user = user;
  }
  setIsAuth(bool: boolean) {
    this._isAuth = bool;
  }
  setIsLoading(isLoading: boolean) {
    this._isLoading = isLoading;
  }
  setUserInfo(userInfo: UserInfo | null) {
    this._userInfo = userInfo;
  }

  get user() {
    return this._user;
  }
  get isAuth() {
    return this._isAuth;
  }
  get userInfo() {
    return this._userInfo;
  }
  get isLoading() {
    return this._isLoading;
  }

  async getUserInfo() {
    try {
      this.setIsLoading(true);
      const userInfo = await fetchUserInfo();
      this.setUserInfo(userInfo);
      this.setIsAuth(true);
    } catch (error) {
      this.setIsAuth(false);
      this.setUserInfo(null);
      console.error("Error fetching user info:", error);
    } finally {
      this.setIsLoading(false);
    }
  }

  logout() {
    void fetchClient("/api/v1/logout", { method: "POST" }).catch(() => undefined);
    this.setIsAuth(false);
    this.setUserInfo(null);
    presaleStore.setClickBuy(false);
  }
}
